"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterTags = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-restricted-syntax */
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importDefault(require("styled-components"));
const react_intl_1 = require("react-intl");
const icons_1 = require("@ant-design/icons");
const types_1 = require("@src/types");
const streamline_icon_official_building_3_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-official-building-3.svg"));
const streamline_icon_close_quote_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-close-quote.svg"));
const offer_filter_context_1 = require("@src/components/pages/offers/offer-filter-context");
const roundSalaryToTen_1 = require("@src/helpers/roundSalaryToTen");
const FilterTag = (0, styled_components_1.default)(elements_1.Tag) `
	display: inline-flex;
	line-height: 2rem;
	font-size: 1rem;
	align-items: center;
	margin-bottom: 0.5rem;

	.ant-tag-close-icon {
		margin-left: 0.75rem;

		& > svg {
			width: 16px;
			height: 16px;
		}
	}
`;
const IconStyled = (0, styled_components_1.default)(elements_1.Icon) `
	z-index: 2;
	top: 30%;
	left: 8px;

	svg {
		width: 16px;
		margin-right: 4px;
	}
`;
const ClearFiltersButton = (0, styled_components_1.default)(elements_1.Button) `
	text-decoration: underline;
`;
const OfferCounts = styled_components_1.default.div `
	margin: 0.75rem 0;
	color: ${({ theme }) => theme.color.gray6};
`;
const TagContainer = styled_components_1.default.div `
	display: inline-flex;
	flex-wrap: wrap;
`;
const FilterTags = ({ offerCounts }) => {
    const offerFilterContextValue = (0, offer_filter_context_1.useOffersFilterContextValue)();
    const intl = (0, react_intl_1.useIntl)();
    const { offersFiltersSSR, typeFiltersSelected, locationFiltersSelected, jobAreaFiltersSelected, searchCompaniesSelected, searchKeywordsSelected, salaryFilter, setTypeFiltersSelected, setLocationFiltersSelected, setJobAreaFiltersSelected, setSearchCompaniesSelected, setSearchKeywordsSelected, setSalaryFilter, highestSalary, changePage, highestGlobalSalary, } = offerFilterContextValue;
    const [showClearFiltersButton, setShowClearFiltersButton] = react_1.default.useState(false);
    const { offersCount, allOffersCount } = offerCounts;
    const isShownMaxNumberOfOffers = offersCount === allOffersCount;
    const isTypeFilterActive = Boolean(typeFiltersSelected && typeFiltersSelected.length);
    const isJobAreaFilterActive = Boolean(jobAreaFiltersSelected && jobAreaFiltersSelected.length);
    const isLocationFilterActive = Boolean(locationFiltersSelected && locationFiltersSelected.length);
    const isSalaryFilterActive = Boolean(salaryFilter.rate);
    const isCompanyFilterActive = Boolean(searchCompaniesSelected && searchCompaniesSelected.length);
    const isKeywordFilterActive = Boolean(searchKeywordsSelected && searchKeywordsSelected.length);
    const removeTypeIdFromFilter = (typeIdToRemove) => {
        const newtypeFiltersSelected = typeFiltersSelected.filter(typeId => typeIdToRemove !== typeId);
        setTypeFiltersSelected(newtypeFiltersSelected);
    };
    const removeJobAreaIdFromFilter = (jobAreaIdToRemove) => {
        const newJobAreaIds = jobAreaFiltersSelected.filter(jobAreaId => jobAreaId !== jobAreaIdToRemove);
        setJobAreaFiltersSelected(newJobAreaIds);
    };
    const removeLocationFromFilter = (locationToRemove) => {
        const newlocationFiltersSelected = locationFiltersSelected.filter(loc => loc !== locationToRemove);
        setLocationFiltersSelected(newlocationFiltersSelected);
    };
    const removeCompanyFromFilter = (companyToRemove) => {
        const newCompanyFiltersSelected = searchCompaniesSelected.filter(co => co.id !== companyToRemove);
        setSearchCompaniesSelected(newCompanyFiltersSelected);
    };
    const removeKeywordFromFilter = (keywordToRemove) => {
        const newKeywordFiltersSelected = searchKeywordsSelected.filter(kw => kw !== keywordToRemove);
        setSearchKeywordsSelected(newKeywordFiltersSelected);
    };
    const getLocationTranslationKeyById = (locationId, currentSublocations) => {
        for (const location of currentSublocations) {
            if (location.id === locationId) {
                return location.translation_key;
            }
            if (location.sublocations) {
                const foundKey = getLocationTranslationKeyById(locationId, location.sublocations);
                if (foundKey) {
                    return foundKey;
                }
            }
        }
    };
    const SalaryTagText = () => {
        const isMaxValueChanged = salaryFilter.maxRange !== salaryFilter.highestSalary;
        const isMinValueChanged = salaryFilter.minRange !== 0;
        const minRangeText = intl.formatNumber(salaryFilter.minRange, {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
        });
        const maxRangeText = intl.formatNumber(salaryFilter.maxRange, {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
        });
        const salaryRateLowercased = intl
            .formatMessage({
            id: `offer.filter.${salaryFilter.rate}`,
        })
            .toLowerCase();
        let rangeText;
        if (isMaxValueChanged && isMinValueChanged) {
            rangeText = `: ${minRangeText} - ${maxRangeText} / ${salaryRateLowercased}`;
        }
        else if (isMaxValueChanged && !isMinValueChanged) {
            rangeText = `: ${intl.formatMessage({ id: 'offers.filter.to' })} ${maxRangeText} / ${salaryRateLowercased}`;
        }
        else if (!isMaxValueChanged && isMinValueChanged) {
            rangeText = `: ${intl.formatMessage({
                id: 'offers.filter.from',
            })} ${minRangeText} / ${salaryRateLowercased}`;
        }
        else {
            rangeText = `: ${salaryRateLowercased}`;
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offers.filter.salary_rate" }), rangeText] }));
    };
    react_1.default.useEffect(() => {
        const filtersCount = typeFiltersSelected.length +
            locationFiltersSelected.length +
            jobAreaFiltersSelected.length +
            Number(isSalaryFilterActive) +
            searchKeywordsSelected.length +
            searchCompaniesSelected.length;
        setShowClearFiltersButton(filtersCount >= 1);
    }, [
        typeFiltersSelected,
        locationFiltersSelected,
        jobAreaFiltersSelected,
        searchKeywordsSelected,
        searchCompaniesSelected,
        salaryFilter,
    ]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: `flex-row align-center ${showClearFiltersButton ? 'justify-space-between' : 'justify-end'}`, children: [showClearFiltersButton && ((0, jsx_runtime_1.jsx)(ClearFiltersButton, { onClick: () => {
                            setSalaryFilter({
                                minRange: 0,
                                maxRange: highestGlobalSalary,
                                highestSalary: highestGlobalSalary,
                                rate: null,
                            });
                            setTypeFiltersSelected([]);
                            setJobAreaFiltersSelected([]);
                            setLocationFiltersSelected([]);
                            setSearchCompaniesSelected([]);
                            setSearchKeywordsSelected([]);
                            changePage(1);
                        }, type: "text", icon: (0, jsx_runtime_1.jsx)(icons_1.ClearOutlined, { className: "m-r-s" }), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offers.clear_selected_filters" }) })), (0, jsx_runtime_1.jsxs)(OfferCounts, { children: [isShownMaxNumberOfOffers && ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { values: {
                                    allOffersCount,
                                }, id: "offers.showing_all_offers_count" })), !isShownMaxNumberOfOffers && ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { values: {
                                    offersCount,
                                    allOffersCount,
                                }, id: "offers.showing_offers_count" }))] })] }), (0, jsx_runtime_1.jsxs)(TagContainer, { children: [isCompanyFilterActive &&
                        searchCompaniesSelected.map(selectedCompany => ((0, jsx_runtime_1.jsx)(FilterTag, { closable: true, onClose: () => removeCompanyFromFilter(selectedCompany.id), children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(streamline_icon_official_building_3_svg_1.default, { width: 16, className: "m-r-s" }), selectedCompany.name] }) }, selectedCompany.id))), isKeywordFilterActive &&
                        searchKeywordsSelected.map(selectedKeyword => ((0, jsx_runtime_1.jsx)(FilterTag, { closable: true, onClose: () => removeKeywordFromFilter(selectedKeyword), children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(streamline_icon_close_quote_svg_1.default, { width: 16, className: "m-r-s" }), `"${selectedKeyword}"`] }) }, selectedKeyword))), offersFiltersSSR && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isTypeFilterActive &&
                                typeFiltersSelected.map(selectedTypeId => {
                                    var _a;
                                    return ((0, jsx_runtime_1.jsx)(FilterTag, { closable: true, onClose: () => removeTypeIdFromFilter(selectedTypeId), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: (_a = offersFiltersSSR.type.find(offerFilter => offerFilter.id === selectedTypeId)) === null || _a === void 0 ? void 0 : _a.translationKey }) }, selectedTypeId));
                                }), isLocationFilterActive &&
                                locationFiltersSelected.map(location => ((0, jsx_runtime_1.jsxs)(FilterTag, { closable: true, onClose: () => removeLocationFromFilter(location), children: [(0, jsx_runtime_1.jsx)(IconStyled, { type: "pin-location" }), location === types_1.ABROAD && (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "location.abroad" }), location === types_1.REMOTE && (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "location.remote" }), location !== types_1.REMOTE && location !== types_1.ABROAD && ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: getLocationTranslationKeyById(location, offersFiltersSSR.location.locations) }))] }, location))), isJobAreaFilterActive &&
                                jobAreaFiltersSelected.map(jobAreaId => {
                                    var _a;
                                    return ((0, jsx_runtime_1.jsx)(FilterTag, { closable: true, onClose: () => removeJobAreaIdFromFilter(jobAreaId), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: (_a = offersFiltersSSR.jobArea.find(offerFilter => offerFilter.id === jobAreaId)) === null || _a === void 0 ? void 0 : _a.translationKey }) }, jobAreaId));
                                }), isSalaryFilterActive && ((0, jsx_runtime_1.jsx)(FilterTag, { closable: true, onClose: () => setSalaryFilter({
                                    rate: null,
                                    minRange: 0,
                                    maxRange: (0, roundSalaryToTen_1.roundSalary)(highestSalary),
                                    highestSalary: (0, roundSalaryToTen_1.roundSalary)(highestSalary),
                                }), children: (0, jsx_runtime_1.jsx)(SalaryTagText, {}) }, salaryFilter.rate))] }))] })] }));
};
exports.FilterTags = FilterTags;
